import { render, staticRenderFns } from "./SearchFilterChip.vue?vue&type=template&id=9a2b627a&scoped=true"
import script from "./SearchFilterChip.vue?vue&type=script&lang=js"
export * from "./SearchFilterChip.vue?vue&type=script&lang=js"
import style0 from "./SearchFilterChip.vue?vue&type=style&index=0&id=9a2b627a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2b627a",
  null
  
)

export default component.exports